// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-item .el-input input.el-input__inner{height:26px;line-height:26px}.setting-item .title-radio{margin-right:15px}.setting-item .no_text{margin-right:5px}.setting-item .no_text .el-radio__label{display:none}", ""]);
// Exports
module.exports = exports;
